// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"8427b6c4","287":"fc278e70","486":"517dc516","651":"3710703a","747":"381c0790","797":"fdf4681b"}[chunkId] + ".chunk.js";
};